<template>
  <div>
    <core-input :value="targetName" :label="`New Name for ${name}`" @input="e => (targetName = e)" />
    <div v-if="structure">
      We are about to localize {{ name.toLowerCase() }} {{ structure.name }} to {{ targetCountry }}
    </div>
    <div class="actions layout justify-end">
      <core-button label="Set Name" not-rounded flat @click="setNewName(targetName)" />
    </div>
  </div>
</template>

<script>
import CoreInput from '../../core/inputs/CoreInput';
import { mapState } from 'vuex';
import CoreButton from '../../core/buttons/CoreButton';
import localization from '@/mixins/localization-mixin';
export default {
  name: 'ChangeName',
  components: { CoreButton, CoreInput },
  mixins: [localization],
  data() {
    return {
      targetName: null
    };
  },
  computed: {
    ...mapState('localization', {
      type: ({ localization }) => localization.type,
      structure: ({ localization }) => localization.structure,
      targetCountry: ({ localization }) => localization.targetCountry
    }),
    name() {
      return this.type === 'flow' ? 'Flow' : 'Chapter';
    }
  }
};
</script>

<style scoped></style>
